import Header from "../../components/Header";
import ContentWrapper from "../../components/ContentWrapper";
import BoxPlanoAllPogs from "./_components/BoxPlanoAllPogs";

const PlanoAllPogs = () => (
  <>
    <div className="px-[10px] pt-[5px]">
      <Header />
    </div>
    <ContentWrapper>
      <BoxPlanoAllPogs />
    </ContentWrapper>
  </>
);

export default PlanoAllPogs;
